var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"child_"},[_c('a-form',{staticClass:"horizontal_item_",attrs:{"layout":"horizontal","form":_vm.form},on:{"submit":_vm.zbSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }